// packages/shared-components/src/components/SettingItem/SettingItem.tsx
import { Switch } from "../Switch";
import { SettingItemProps } from "./types";
import styles from "./SettingItem.module.css";

export function SettingItem({
  title,
  description,
  checked,
  defaultChecked,
  onChange,
  disabled = false,
  compact = false,
  className = "",
  children,
}: SettingItemProps) {
  return (
    <div
      className={`${styles.settingItem} ${
        compact ? styles.compact : ""
      } ${disabled ? styles.disabled : ""} ${className}`}
    >
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        {description && <p className={styles.description}>{description}</p>}
      </div>
      <div className={styles.control}>
        {children || (
          <Switch
            checked={checked}
            defaultChecked={defaultChecked}
            onChange={onChange}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
}
